import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateUserApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateUser = createAsyncThunk('updateUser', async (payload) => {
  return await updateUserApi(payload);
});

const updateUserSlice = createSlice({
  name: 'updateUser', // Unique Name
  initialState,
  reducers: {
    updateUserReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUser.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateUserReset } = updateUserSlice.actions;

export default updateUserSlice.reducer;
